import {
    FETCH_DATA_ANALYTICS_REQUEST,
    FETCH_DATA_ANALYTICS_SUCCESS,
    FETCH_DATA_ANALYTICS_FAILURE,
} from '../../actions/analytics/get-analytics-actions';

const initialState = {
    analytics: null,
    isLoading: false,
    error: null,
    meta: null
};

const getAnalyticsReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DATA_ANALYTICS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DATA_ANALYTICS_SUCCESS:
            console.log("analytic", action.payload);
            return {
                ...state,
                isLoading: false,
                analytics: action.payload,
            };
        case FETCH_DATA_ANALYTICS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default getAnalyticsReducer;